import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import EquipmentOptionsRow from './EquipmentOptionsRow';

class EquipmentOptionsList extends React.Component {

    constructor(props) {
        super(props);
        this.submitOptions = this
            .submitOptions
            .bind(this);

        this.clearOptions = this
            .clearOptions
            .bind(this);
    }

    submitOptions() {
        const { orderId, accountNumber, billingSystem, equipmentOptions, workOrderActions, techId } = this.props;
        const selectedOptions = equipmentOptions.get('selectedOptions');
        const availableOptions = equipmentOptions.getIn(['details', 'serviceCodeList']);
        const serviceCodesToSubmit = [];

        selectedOptions.forEach(function (item) {
            const fullOption = availableOptions.find(function (element) {
                return element.get('code') === item.code;
            });

            serviceCodesToSubmit.push({
                code: fullOption.get('code'),
                description: fullOption.get('description'),
                portType: fullOption.get('portType'),
                billingProductCode: fullOption.get('billingProductCode'),
                billingProductType: fullOption.get('billingProductType'),
                cost: fullOption.get('cost'),
                quantity: item.quantity,
                isEquipment: fullOption.get('isEquipment')
            });
        });

        const request = {
            "accountNumber": accountNumber,
            "jobNumber": orderId,
            "serviceCodeList": serviceCodesToSubmit,
            "billingSystem": billingSystem,
            "techId": techId
        };

        this.clearOptions();
        workOrderActions.equipmentOptionSubmitStarted(request, orderId);

        setTimeout(() => {
            workOrderActions.clearWorkOrderDetail(orderId, 'orderServices');
            workOrderActions.clearWorkOrderDetail(orderId, 'equipmentDetails');
        }, 30000);

    }

    clearOptions() {
        const { orderId, workOrderActions } = this.props;
        workOrderActions.equipmentOptionClear(orderId);
    }

    render() {
        const { equipmentOptions, orderId, workOrderActions, equipmentDetails} = this.props;

        if (!equipmentOptions || !equipmentOptions.get('details') || !equipmentOptions.getIn(['details', 'serviceCodeList']) || equipmentOptions.getIn(['details', 'serviceCodeList']).count() === 0) {
            return (
                <div style={{
                    textAlign: 'center'
                }}>
                    <h6>No Options Found</h6>
                </div>
            );
        }

        let submitMessageDisplay = null;
        let messageColor = 'lightgreen';
        if (equipmentOptions.get('submitSuccess') === false) {
            messageColor = 'salmon';
        }

        if (equipmentOptions.get('submitMessage')) {
            submitMessageDisplay = (
                <div style={{
                    textAlign: 'center',
                    color: messageColor
                }}>{equipmentOptions.get('submitMessage')}</div>
            );
        }

        const selectedOptions = equipmentOptions.get('selectedOptions');
        const sortedOptions = equipmentOptions
            .getIn(['details', 'serviceCodeList'])
            .sortBy(item => item.get('description'));

        const equipmentRows = sortedOptions.filter(row => row.get('isEquipment'))
            .map((item, index) => {
                return (<EquipmentOptionsRow
                    selectedOptions={selectedOptions}
                    equipmentOption={item}
                    workOrderActions={workOrderActions}
                    orderId={orderId}
                    index={index}
                    key={'equipment_option_row_' + index}
                    equipmentDetails={equipmentDetails} />);
            });

        const colStyle = {
            padding: '.5rem'
        };
        const labelStyle = {
            fontSize: '11px',
            paddingLeft: '8px',
            paddingRight: '8px'

        };
        return (
            <div style={{
                overflowY: 'hidden'
            }}>
                <div
                    className="row"
                    style={{
                        marginTop: '5px',
                        marginBottom: '-5px',
                        marginLeft: '3px',
                        marginRight: '3px'
                    }}>
                    <div className="col s6" style={colStyle}>
                        <RaisedButton
                            fullWidth
                            labelStyle={labelStyle}
                            onTouchTap={this.submitOptions}
                            label="Submit" />
                    </div>
                    <div className="col s6" style={colStyle}>
                        <RaisedButton
                            fullWidth
                            labelStyle={labelStyle}
                            onTouchTap={this.clearOptions}
                            label="Reset" />
                    </div>
                </div>
                {submitMessageDisplay}
                <div>
                    <table className="table bordered striped condensed">
                        <tbody>
                            {equipmentRows}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

EquipmentOptionsList.propTypes = {
    equipmentOptions: PropTypes.object,
    techId: PropTypes.string,
    orderId: PropTypes.string,
    accountNumber: PropTypes.string,
    billingSystem: PropTypes.string,
    workOrderActions: PropTypes.object,
    equipmentDetails: PropTypes.object
};

export default EquipmentOptionsList;


// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentOptionsList.js